import { registerComponent } from '@gig/magic-common';
import SweepstakesMailCodeComponent from './sweepstakes-mail-code.vue.js';

var SweepstakesMailCode = registerComponent(SweepstakesMailCodeComponent);

export { SweepstakesMailCode };
